export default {
  name: 'marking--orderM',
  apiService: 'shoes',
  apiPath: '/admin/order_m',
};